/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"
import { StoreBrandFeedbackRequestParams, StoreBrandFeedbackResponse, StoreBrandRequestRequestParams, StoreBrandRequestResponse } from "./rent.types"

export default ($axios: any): any => ({
  async index(data: any) {
    return camelize(await $axios.get("/rental", { params: snakelize(data) }))
  },

  // 대여하기
  async store(data?: any) {
    return camelize(await $axios.post(`/rental`, snakelize(data)))
  },

  async storeTrackingNumber(data?: any) {
    return camelize(await $axios.post(`/rental/tracking`, snakelize(data)))
  },

  async storePrepareDt(data?: any) {
    return camelize(await $axios.post(`/rental/prepare`, snakelize(data)))
  },

  async storeBrandFeedback(data?: StoreBrandFeedbackRequestParams): Promise<StoreBrandFeedbackResponse> {
    return camelize(await $axios.post(`/rental/brand-feedback`, snakelize(data)))
  },

  async storeBrandRequest(data?: StoreBrandRequestRequestParams): Promise<StoreBrandRequestResponse> {
    return camelize(await $axios.post(`/rental/brand-request`, snakelize(data)))
  },
})
